import type { ReactNode } from 'react';
import { CreditCard } from 'lucide-react';

import type { MatchInquirySummary, MatchTerminatedMatch } from '../types';
import { ReportCard } from '../../composites';
import { MatchesTable } from './MatchesTable';
import { RawJsonDialog } from './RawJsonDialog';

const formatDate = (value: string) => {
  const date = new Date(value);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${mm}/${dd}/${date.getFullYear()}`;
};

const SummaryItem = ({ label, children }: { label: string; children: ReactNode }) => (
  <div className="space-y-1">
    <p className="text-sm text-slate-400">{label}</p>
    <div className="text-sm font-medium text-slate-900">{children}</div>
  </div>
);

/** The "MATCH Results" section: summary stats + the terminated-matches table. */
export const MatchResultsSection = ({
  summary,
  terminatedMatches = [],
}: {
  summary?: MatchInquirySummary | null;
  terminatedMatches?: MatchTerminatedMatch[];
}) => (
  <ReportCard title="MATCH Results" Icon={CreditCard} showTooltip={false}>
    <div className="space-y-8">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        <SummaryItem label="Terminated Matches">{summary?.terminatedMatchesCount ?? 0}</SummaryItem>
        <SummaryItem label="Check Date">
          {summary?.checkDate ? formatDate(summary.checkDate) : '—'}
        </SummaryItem>
        <SummaryItem label="Full JSON Data">
          <RawJsonDialog rawJson={summary?.rawJson} />
        </SummaryItem>
      </div>

      <MatchesTable title="Terminated Merchants Matches" matches={terminatedMatches} />
    </div>
  </ReportCard>
);
